export default "__VITE_ASSET__DbeVomAs__"